/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ListNodeOverlaysResponse } from '../models';
// @ts-ignore
import type { NodeOverlay } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * NodeOverlaysAPIApi - axios parameter creator
 * @export
 */
export const NodeOverlaysAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a single NodeOverlay by name from the latest snapshot.
         * @summary Gets a NodeOverlay by name.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The name of the NodeOverlay.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeOverlaysAPIGetNodeOverlay: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeOverlaysAPIGetNodeOverlay', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodeOverlaysAPIGetNodeOverlay', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('nodeOverlaysAPIGetNodeOverlay', 'id', id)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/node-overlays/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists NodeOverlays for a cluster as observed in the latest snapshot.
         * @summary Lists NodeOverlays.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeOverlaysAPIListNodeOverlays: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeOverlaysAPIListNodeOverlays', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodeOverlaysAPIListNodeOverlays', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/node-overlays`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodeOverlaysAPIApi - functional programming interface
 * @export
 */
export const NodeOverlaysAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodeOverlaysAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a single NodeOverlay by name from the latest snapshot.
         * @summary Gets a NodeOverlay by name.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The name of the NodeOverlay.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeOverlaysAPIGetNodeOverlay(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeOverlay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeOverlaysAPIGetNodeOverlay(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeOverlaysAPIApi.nodeOverlaysAPIGetNodeOverlay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists NodeOverlays for a cluster as observed in the latest snapshot.
         * @summary Lists NodeOverlays.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeOverlaysAPIListNodeOverlays(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNodeOverlaysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeOverlaysAPIListNodeOverlays(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeOverlaysAPIApi.nodeOverlaysAPIListNodeOverlays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NodeOverlaysAPIApi - factory interface
 * @export
 */
export const NodeOverlaysAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodeOverlaysAPIApiFp(configuration)
    return {
        /**
         * Returns a single NodeOverlay by name from the latest snapshot.
         * @summary Gets a NodeOverlay by name.
         * @param {NodeOverlaysAPIApiNodeOverlaysAPIGetNodeOverlayRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeOverlaysAPIGetNodeOverlay(requestParameters: NodeOverlaysAPIApiNodeOverlaysAPIGetNodeOverlayRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeOverlay> {
            return localVarFp.nodeOverlaysAPIGetNodeOverlay(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists NodeOverlays for a cluster as observed in the latest snapshot.
         * @summary Lists NodeOverlays.
         * @param {NodeOverlaysAPIApiNodeOverlaysAPIListNodeOverlaysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeOverlaysAPIListNodeOverlays(requestParameters: NodeOverlaysAPIApiNodeOverlaysAPIListNodeOverlaysRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListNodeOverlaysResponse> {
            return localVarFp.nodeOverlaysAPIListNodeOverlays(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for nodeOverlaysAPIGetNodeOverlay operation in NodeOverlaysAPIApi.
 * @export
 * @interface NodeOverlaysAPIApiNodeOverlaysAPIGetNodeOverlayRequest
 */
export interface NodeOverlaysAPIApiNodeOverlaysAPIGetNodeOverlayRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof NodeOverlaysAPIApiNodeOverlaysAPIGetNodeOverlay
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof NodeOverlaysAPIApiNodeOverlaysAPIGetNodeOverlay
     */
    readonly clusterId: string

    /**
     * The name of the NodeOverlay.
     * @type {string}
     * @memberof NodeOverlaysAPIApiNodeOverlaysAPIGetNodeOverlay
     */
    readonly id: string
}

/**
 * Request parameters for nodeOverlaysAPIListNodeOverlays operation in NodeOverlaysAPIApi.
 * @export
 * @interface NodeOverlaysAPIApiNodeOverlaysAPIListNodeOverlaysRequest
 */
export interface NodeOverlaysAPIApiNodeOverlaysAPIListNodeOverlaysRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof NodeOverlaysAPIApiNodeOverlaysAPIListNodeOverlays
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof NodeOverlaysAPIApiNodeOverlaysAPIListNodeOverlays
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof NodeOverlaysAPIApiNodeOverlaysAPIListNodeOverlays
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof NodeOverlaysAPIApiNodeOverlaysAPIListNodeOverlays
     */
    readonly pageCursor?: string
}

/**
 * NodeOverlaysAPIApi - object-oriented interface
 * @export
 * @class NodeOverlaysAPIApi
 * @extends {BaseAPI}
 */
export class NodeOverlaysAPIApi extends BaseAPI {
    /**
     * Returns a single NodeOverlay by name from the latest snapshot.
     * @summary Gets a NodeOverlay by name.
     * @param {NodeOverlaysAPIApiNodeOverlaysAPIGetNodeOverlayRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeOverlaysAPIApi
     */
    public nodeOverlaysAPIGetNodeOverlay(requestParameters: NodeOverlaysAPIApiNodeOverlaysAPIGetNodeOverlayRequest, options?: RawAxiosRequestConfig) {
        return NodeOverlaysAPIApiFp(this.configuration).nodeOverlaysAPIGetNodeOverlay(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists NodeOverlays for a cluster as observed in the latest snapshot.
     * @summary Lists NodeOverlays.
     * @param {NodeOverlaysAPIApiNodeOverlaysAPIListNodeOverlaysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeOverlaysAPIApi
     */
    public nodeOverlaysAPIListNodeOverlays(requestParameters: NodeOverlaysAPIApiNodeOverlaysAPIListNodeOverlaysRequest, options?: RawAxiosRequestConfig) {
        return NodeOverlaysAPIApiFp(this.configuration).nodeOverlaysAPIListNodeOverlays(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

